import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, Observable, of, switchMap, take } from 'rxjs';
import { EasyDgdDataState } from '../store/easydgd-data.reducer';
import { selectInitialized } from '../store/easydgd-data.selectors';
import { initStepperSuccess } from '../store/easydgd-data.actions';
import { LanguageService } from '@hazmatsuite-next/ui';
import { steps } from '@hazmatsuite-next/easydgd-lib';

export const initStepperResolver: ResolveFn<Observable<null>> = (route, state) => {
  const store = inject(Store<{ easyDgdState: EasyDgdDataState }>);
  const languageService = inject(LanguageService);
  return store.select(selectInitialized).pipe(
    take(1),
    switchMap(initialized => {
      if (!initialized) {
        return languageService.translations$.pipe(
          map((translations => {
            const stepperItems = steps(translations);
            store.dispatch(initStepperSuccess({ steps: stepperItems }));
            return null;
          }))
        )
      }
      return of(null);
    })
  );
};
